#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);

  &.update-context {
    .license-form-section {
      width: auto;
    }

    .subtitle {
      max-width: fit-content;
    }
  }
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  --font-family: 'Montserrat', sans-serif;
}

.subtitle {
  display: block;
  margin: calc(var(--spacer) * 2) 0 0 0;
  padding: 0;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-large);
  max-width: 600px;
  line-height: 21px;
}

.tooltip-form-field-section {
  display: flex;
  flex-direction: row;
  justify-items: start;

  gz-tooltip {
    margin-left: var(--spacer);
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 24px;
      line-height: 0.8;
      color: var(--chart-300-icon-buttons);
    }
  }
}

.text-form-field-section {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
}

.subform-section {
  display: flex;
  flex-direction: column;

  .subform-section-label {
    text-align: left;

    &:after {
      content: ':';
    }
  }
}

.toggle-field {
  --label-width: 450px;
  --form-field-max-width: 400px;
}

.toggle-field-indented {
  --label-width: 385px;
  --form-field-max-width: 400px;
}

.license-form-section {
  width: 800px;
}

#products-section-title {
  margin-top: calc(var(--spacer) * 5);
}

#own-use-product-type-form-field {
  margin-top: calc(var(--spacer) * 2);
  max-width: 240px;
}

// temporary fix for the ticket (FED-1933)
gz-form-field-toggleable {
  &::part(input-wrapper) {
    width: auto;
  }
}

gz-form-field {
  &::part(form-field-label) {
    min-width: 160px;
    max-width: 160px;
    text-align: left;
  }
}

.products-section {
  .subform-section-label {
    min-width: 160px;
    max-width: 160px;
  }
}

gz-dropdown {
  text-align: left;
}
